<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <ListaConfigNiveis />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import ListaConfigNiveis from "../Components/Listagens/ListaConfigNiveis.vue";
export default {
  name: "ListConfigLevels",
  components: {
    ListaConfigNiveis,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
